import React from 'react';
import ReactDOM from 'react-dom/client';
import { SearchExplanationPage } from './SearchExplanationPage';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: unknown;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <SearchExplanationPage {...data} />
  </React.StrictMode>
);
